export default {
  'pages.applicationFeedback.factoryIssue': 'ソフトウェア工場の課題',
  'pages.applicationFeedback.factoryIssueNotAdded': '未追加',
  'pages.applicationFeedback.factoryIssueAdding': '追加中',
  'pages.applicationFeedback.factoryIssueFailed': '追加失敗',
  'pages.applicationFeedback.factoryIssuePartiallyAdded':
    '課題作成済み・関連付け未完了',
  'pages.applicationFeedback.factoryIssueDeleted': '関連課題は削除済み',
  'pages.applicationFeedback.readdToSoftwareFactory':
    'ソフトウェア工場に再追加',
  'pages.applicationFeedback.factoryIssueId': '課題 ID',

  'pages.applicationFeedback.organizationFilter': '組織で絞り込み',
  'pages.applicationFeedback.retrySoftwareFactory':
    'ソフトウェア工場への追加を再試行',
  'pages.applicationFeedback.title': 'アプリのフィードバック',
  'pages.applicationFeedback.feedback': 'フィードバック',
  'pages.applicationFeedback.searchPlaceholder': 'タイトルまたは内容を検索',
  'pages.applicationFeedback.type': '種類',
  'pages.applicationFeedback.status': 'ステータス',
  'pages.applicationFeedback.priority': '優先度',
  'pages.applicationFeedback.application': 'アプリ',
  'pages.applicationFeedback.applications': 'アプリ一覧',
  'pages.applicationFeedback.allFeedback': 'すべてのフィードバック',
  'pages.applicationFeedback.pluginApplication': 'プラグインアプリ',
  'pages.applicationFeedback.pcApplication': 'PC アプリ',
  'pages.applicationFeedback.searchApplications': 'アプリ名または ID を検索',
  'pages.applicationFeedback.refreshApplications': 'アプリ一覧を更新',
  'pages.applicationFeedback.noApplications':
    'フィードバックのあるアプリはありません',
  'pages.applicationFeedback.noFeedback': 'フィードバックはありません',
  'pages.applicationFeedback.applicationsUnavailable':
    'アプリ一覧を読み込めません',
  'pages.applicationFeedback.unknownApplication': '未連携のアプリ',
  'pages.applicationFeedback.unknownName': '不明',
  'pages.applicationFeedback.unknownSubmitter': '投稿者不明',
  'pages.applicationFeedback.tenant': 'テナント',
  'pages.applicationFeedback.tenantFilter': 'テナントで絞り込み',
  'pages.applicationFeedback.submitter': '投稿者',
  'pages.applicationFeedback.operator': 'プラットフォーム担当者',
  'pages.applicationFeedback.createdAt': '投稿日時',
  'pages.applicationFeedback.lastActivity': '最終更新',
  'pages.applicationFeedback.contact': '連絡先',
  'pages.applicationFeedback.pageUrl': 'ページ',
  'pages.applicationFeedback.viewScreenshot': 'スクリーンショットを表示',
  'pages.applicationFeedback.attachments': '添付ファイル',
  'pages.applicationFeedback.previewAttachment': '添付ファイルをプレビュー',
  'pages.applicationFeedback.downloadAttachment': '添付ファイルをダウンロード',
  'pages.applicationFeedback.popupBlocked':
    '添付ファイルのウィンドウがブロックされました。ポップアップを許可して再試行してください。',
  'pages.applicationFeedback.actions': '操作',
  'pages.applicationFeedback.detail': '詳細',
  'pages.applicationFeedback.addToSoftwareFactory': 'ソフトウェア工場に追加',
  'pages.applicationFeedback.addedToSoftwareFactory':
    'ソフトウェア工場に追加済み',
  'pages.applicationFeedback.addToSoftwareFactorySuccess':
    'ソフトウェア工場に追加しました',
  'pages.applicationFeedback.softwareFactoryProjectMissing':
    'プロジェクト情報がないため、課題を作成できません',
  'pages.applicationFeedback.replies': '返信',
  'pages.applicationFeedback.activity': '対応履歴',
  'pages.applicationFeedback.noReplies': '返信はありません',
  'pages.applicationFeedback.replyPlaceholder': '返信を入力',
  'pages.applicationFeedback.replyRequired': '返信を入力してください',
  'pages.applicationFeedback.sendReply': '返信を送信',
  'pages.applicationFeedback.replySuccess': '返信を送信しました',
  'pages.applicationFeedback.updateSuccess': 'フィードバックを更新しました',
  'pages.applicationFeedback.refresh': '更新',
  'pages.applicationFeedback.empty': 'フィードバックはありません',
  'pages.applicationFeedback.totalCount': '合計 {count} 件',
  'pages.applicationFeedback.detailUnavailable': '詳細を読み込めません',
  'pages.applicationFeedback.type.bug': '不具合報告',
  'pages.applicationFeedback.type.feature': '機能リクエスト',
  'pages.applicationFeedback.type.optimization': '改善提案',
  'pages.applicationFeedback.type.other': 'その他',
  'pages.applicationFeedback.status.pending': '未対応',
  'pages.applicationFeedback.status.processing': '対応中',
  'pages.applicationFeedback.status.resolved': '解決済み',
  'pages.applicationFeedback.status.closed': '終了',
  'pages.applicationFeedback.status.withdrawn': '取り下げ',
  'pages.applicationFeedback.priority.low': '低',
  'pages.applicationFeedback.priority.medium': '中',
  'pages.applicationFeedback.priority.high': '高',
};
